import { render, staticRenderFns } from "./insertOtherCells.vue?vue&type=template&id=0b80ede2&scoped=true"
import script from "./insertOtherCells.vue?vue&type=script&lang=js"
export * from "./insertOtherCells.vue?vue&type=script&lang=js"
import style0 from "./insertOtherCells.vue?vue&type=style&index=0&id=0b80ede2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b80ede2",
  null
  
)

export default component.exports